import type { IAgreementService } from "./agreement.types"
import type { IAgreementData } from "@/models/agreement"
import axios from "@/api/axios"
import type { AxiosInstance } from "axios"

export class AgreementService implements IAgreementService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/agreements/'
  }

  fetchActiveAgreement(): Promise<IAgreementData> {
    return this.axios.get(`${this.endpoint}active/`)
      .then(({ data }) => data)
  }

  recordAcceptance(version: string): Promise<void> {
    return this.axios.post(`${this.endpoint}accept/`, { version })
  }
}

const agreementService = new AgreementService(axios)
export default agreementService
